import dayjs, { type Dayjs } from 'dayjs';

export const startOfDay = (date?: string | Dayjs) =>
  dayjs(date).utc(true).startOf('day').toISOString();
